import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LibOptionValue } from "daisy-design-system-front";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { FieldsetModule } from "primeng/fieldset";
import {ExportRequestStateSampling} from '../../../../../swagger-gen/gnvert-secured/models/export-request-state-sampling';
import {MatRadioButton, MatRadioGroup} from '@angular/material/radio';

@Component({
  selector: "app-select-station-sampling",
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FieldsetModule, MatRadioGroup, MatRadioButton],
  templateUrl: "./select-station-sampling.component.html",
  styleUrls: ["./select-station-sampling.component.scss"],
})
export class SelectStationSamplingComponent implements OnInit {
  @Input() valueFormControl = new FormControl<ExportRequestStateSampling>(ExportRequestStateSampling.HOUR);

  public stationSamplings: LibOptionValue<string>[] = [];

  constructor(private readonly translate: TranslateService) {}

   ngOnInit(): void {
     this.stationSamplings = Object.values(ExportRequestStateSampling).map(
       (value) => ({
         label: this.translate.instant(`export-creation.fields.sampling.values.${value}`),
         value: value,
       })
     );
   }
}
